
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import swal from "sweetalert";
import { getPostData } from "../../ApiMethods/ApiMethods";

function OtpVerify() {
  const [otp, setOtp] = useState(["", "", "", ""]); 
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputRefs = useRef([]); 
  const calledOnce = useRef(false); 

  const getMobileNo = () => {
    try {
      const userDataString = sessionStorage.getItem("UserData");
      if (!userDataString) return "";
      const userData = JSON.parse(userDataString);
      return userData?.MobileNo || "";
    } catch (e) {
      return "";
    }
  };

  const mobileNo = getMobileNo();

  
  useEffect(() => {
    if (calledOnce.current) return;
    if (mobileNo) {
      getPostData("SMS/GetData_SMS", { MobileNo: mobileNo }).catch(() => {});
      calledOnce.current = true;
    }
  }, [mobileNo]);

  
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

 
  useEffect(() => {
    const otpValue = otp.join("");
    if (otpValue.length === otp.length && otp.every(digit => digit !== "")) {
      onSubmit(new Event("submit"));
    }
  }, [otp]);

  const handleChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value.slice(-1); 
      setOtp(newOtp);

      if (value && index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const clearOtp = () => {
    setOtp(["", "", "", ""]);
    if (inputRefs.current[0]) inputRefs.current[0].focus(); 
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join(""); 

    if (!otpValue) {
      swal("Required", "Please enter OTP", "warning");
      return;
    }
    if (!mobileNo) {
      swal("Error", "Mobile number not found in session. Please login again.", "error");
      navigate("/login");
      return;
    }

    try {
      setSubmitting(true);
      const res = await getPostData("SMS/Check_Otp", {
        Otp: otpValue,
        MobileNo: mobileNo,
      });

      const status = res?.[0]?.Status;

      if (status === "true") {
        const userDataString = sessionStorage.getItem('UserData');
        if (userDataString) {
          const userData = JSON.parse(userDataString);
          const updatedUserData = {
            ...userData,
            isOtpVerified: true,
            requiresOtpVerification: false
          };
          sessionStorage.setItem('UserData', JSON.stringify(updatedUserData));
          dispatch({ type: 'OTP_VERIFIED', payload: updatedUserData });
        }

        swal("Success", "OTP verified successfully", "success");
        navigate("/dashboard");
      } else {
        swal("Invalid OTP", "Please try again", "error");
        clearOtp(); 
      }
    } catch (error) {
      swal("Invalid OTP", "Please try again", "error");
      clearOtp(); 
    } finally {
      setSubmitting(false);
    }
  };

  const onResend = async () => {
    if (!mobileNo) {
      swal("Error", "Mobile number not found in session. Please login again.", "error");
      navigate("/login");
      return;
    }
    try {
      setSubmitting(true);
      await getPostData("SMS/GetData_SMS", { MobileNo: mobileNo });
      swal("Sent", "OTP resent successfully", "success");
      clearOtp(); 
    } catch (error) {
      swal("Error", "Failed to resend OTP", "error");
    } finally {
      setSubmitting(false);
    }
  };

   return (
    <div className="authincation d-flex flex-column flex-lg-row flex-column-fluid">
      <div className="login-aside text-center d-flex flex-column flex-row-auto">
        <div className="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
          <div className="text-center mb-3 pt-1">
            <img src="../../../images/logo1.png" alt="" style={{ width: '80px' }} />
          </div>
          <h3 className="mb-2">OTP Verification</h3>
        </div>
        <div className="aside-image" style={{ backgroundImage: 'url(../../../images/pic1.png)' }}></div>
      </div>
      
      <div className="container flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
        <div className="d-flex justify-content-center h-100 align-items-center">
          <div className="authincation-content style-2">
            <div className="row no-gutters">
              <div className="col-xl-12 tab-content">
                <div id="sign-in" className="auth-form form-validation">
                  <div className="text-center mb-4">
                    <h4 className="text-center mb-3">Verify OTP</h4>
                    {mobileNo ? (
                      <p className="text-muted">We've sent a verification code to <strong>{mobileNo}</strong></p>
                    ) : (
                      <div className="alert alert-danger">
                        Mobile number not found. Please login again.
                      </div>
                    )}
                  </div>
                  
                  <form onSubmit={onSubmit}>
                    <div className="form-group mb-4">
                      <label className="mb-2"><strong>Enter 4-digit OTP</strong></label>
                      <div className="d-flex gap-2 justify-content-center mb-3">
                        {otp.map((digit, i) => (
                          <input
                            key={i}
                            ref={(el) => (inputRefs.current[i] = el)}
                            type="text"
                            className="form-control text-center"
                            style={{
                              width: "60px",
                              height: "60px",
                              fontSize: "24px",
                              fontWeight: "bold",
                              borderRadius: "8px"
                            }}
                            maxLength="1"
                            value={digit}
                            onChange={(e) => handleChange(e.target.value, i)}
                            onKeyDown={(e) => handleKeyDown(e, i)}
                            disabled={!mobileNo || submitting}
                          />
                        ))}
                      </div>
                    </div>
                    
                    <div className="text-center mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary btn-block"
                        disabled={submitting || !mobileNo}
                      >
                        {submitting ? 'Verifying...' : 'Verify OTP'}
                      </button>
                      
                      <div className="mt-3">
                        <p className="mb-0">
                          Didn't receive code?{' '}
                          <button
                            type="button"
                            className="btn btn-link p-0"
                            onClick={onResend}
                            disabled={submitting || !mobileNo}
                          >
                            Resend OTP
                          </button>
                        </p>
                      </div>
                      
                      <div className="mt-3">
                        <button
                          type="button"
                          className="btn btn-link"
                          onClick={() => navigate('/login')}
                        >
                          Back to Login
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export default OtpVerify;
